import { TYPE } from "./constants"

export const getImageSize = departReturn => {
  if (departReturn.segments.length > 1) {
    return 64
  }
  return 128
}
export const getCarriers = (
  trip,
  carrierObject = {},
  content = {}
) => {
  const randomKey = typeof(window)==="undefined" ? "aarumnee" : window.localStorage.getItem("randomKey")
  const carriers = []
  const contentObj = content[trip.airlineProfile]
    ? content[trip.airlineProfile][0]
    : content || {}
  const segments =
    "flightDetails" in trip ? trip.flightDetails.segments : trip.segments
  segments.forEach(data => {
    const carrier = {}
    carrier.operatingCarrierName = carrierObject[data.operatingCarrierCode]
    carrier.operatingCarrierCode = data.operatingCarrierCode
    carrier.operatingFlightNumber = data.operatingFlightNumber
    carrier.marketingCarrierName = carrierObject[data.marketingCarrierCode]
    carrier.marketingCarrierCode = data.marketingCarrierCode
    carrier.marketingFlightNumber = data.marketingFlightNumber
    carrier.type = data.fareType
    carrier.cabinClass = data.fareClassCategory
    carrier.image = `${contentObj &&
      contentObj.images &&
      contentObj.images[0].carrierLogo64.replace(
        "{carrier_code}",
        data.marketingCarrierCode
      )}?default=airline.png&key=${randomKey}`
    return carriers.push(carrier)
  })
  return carriers
}

const getDesignator = (leg, stations = {}) => {
  const designator = {}
  designator.departureStation =
    stations[leg.designator.departureStation] !== undefined
      ? stations[leg.designator.departureStation].StationName
      : leg.designator.departureStation
  designator.departureTime = leg.designator.departureTime
  designator.arrivalStation =
    stations[leg.designator.arrivalStation] !== undefined
      ? stations[leg.designator.arrivalStation].StationName
      : leg.designator.arrivalStation
  designator.arrivalTime = leg.designator.arrivalTime
  return designator
}

export const getSegments = (segmentsData, stations) => {
  const segments = []
  const segmentToUse =
    "flightDetails" in segmentsData
      ? segmentsData.flightDetails.segments
      : segmentsData.segments
  segmentToUse.forEach(data => {
    data.legs.forEach(leg => {
      const segment = {}
      segment.designator = getDesignator(leg, stations)
      if (data.legs.length > 1) {
        segment.duration = leg.duration
        segment.layoverTime = leg.layoverTime
      } else {
        segment.duration = data.duration
        segment.layoverTime = data.layoverTime
      }
      segments.push(segment)
    })
  })
  return segments
}
const getGovtApprovalStatus = segments => {
  let subjectToGovtApproval = false
  segments.forEach(data => {
    if ("subjectToGovtApproval" in data && data.subjectToGovtApproval) {
      subjectToGovtApproval =
        subjectToGovtApproval || data.subjectToGovtApproval
    }
  })
  return subjectToGovtApproval
}
const getJourney = (
  data,
  carriers,
  stations,
  content,
  tripType,
  type,
  airlineProfile
) => {
  const journey = {}
  let departReturnObject
  if (type === TYPE.BUNDLED) {
    departReturnObject =
      tripType && tripType === "R"
        ? data?.flightDetails?.return
        : data?.flightDetails?.depart
  } else {
    departReturnObject = data
  }

  if (!departReturnObject) {
    return null
  }

  departReturnObject.airlineProfile =
    departReturnObject.airlineProfile || airlineProfile || "kiwi"
  journey.carriers = getCarriers(departReturnObject, carriers, content)
  journey.designator =
    "flightDetails" in departReturnObject
      ? departReturnObject.flightDetails.designator
      : departReturnObject.designator
  journey.segments = getSegments(departReturnObject, stations)
  journey.subjectToGovtApproval = getGovtApprovalStatus(
    "flightDetails" in departReturnObject
      ? departReturnObject.flightDetails.segments
      : departReturnObject.segments
  )
  return journey
}

export const getJourneyHelper = (
  searchResults = {},
  data,
  id,
  content,
  type,
  airlineProfile
) => {
  const journeys = []

  let journey = getJourney(
    data,
    searchResults.carriers,
    searchResults.stations,
    content,
    null,
    type,
    airlineProfile
  )

  if (journey) {
    journeys.push(journey)
  }

  if (data.tripType === "R" && type === TYPE.BUNDLED) {
    let returnObj
    if (type === TYPE.BUNDLED) {
      returnObj = data.flightDetails.return
    } else {
      returnObj = data
    }

    journey = getJourney(
      returnObj,
      (searchResults && searchResults.carriers) || {},
      (searchResults && searchResults.stations) || {},
      content,
      null,
      data.tripType,
      airlineProfile
    )

    if (journey) {
      journeys.push(journey)
    }
  }

  return journeys
}

// Get Baggage Icon
const getBaggageIcon = baggageType => {
  const baseIconUrl = "https://a.staticaa.com/images/icon/"
  switch (baggageType) {
    case "hold_bag":
      return `${baseIconUrl}baggage_large.svg`
    case "cabin_bag":
      return `${baseIconUrl}baggage_sml.svg`
    case "hand_carry":
      return `${baseIconUrl}baggage_sml.svg`
    default:
      return `${baseIconUrl}backpack.svg`
  }
}

// Get Baggage Name
const getBaggageDisplayName = (bagType, translation = {}) => {
  const bagDisplayObj = {
    hold_bag: "holdBag",
    cabin_bag: "cabinBag",
    personal_item: "personalItem"
  }

  const bagTypeName = bagType in bagDisplayObj ? bagDisplayObj[bagType] : ""
  return bagTypeName && translation[bagTypeName] ? translation[bagTypeName] : ""
}

const getBaggageMainDisplayNameQty = bag => {
  if (!bag.weight && bag.count) {
    return null
  }

  return bag.count
}

const getPieceTranslation = (count, translation = {}) => {
  if (count === 0) {
    return ""
  }

  const pieceTranslation =
    count > 1 ? translation.baggagePieces : translation.baggagePiece

  return pieceTranslation.replace("{0}", count.toString())
}

const getBaggageValue = (bag, translation) => {
  return bag.weight
    ? `${bag.weight} kg`
    : getPieceTranslation(bag.count, translation?.listing)
}

// Get Journey Baggage Info
export const getJourneyBaggageInfo = (tripData, translation) => {
  const baggageObj = {}
  if (
    tripData.flightDetails.baggage &&
    tripData.flightDetails.baggage.complimentaryBaggage
  ) {
    baggageObj.showBaggageAllowance = !!tripData.flightDetails.baggage
      .complimentaryBaggage
    baggageObj.hasNoCheckedBaggage = !tripData.flightDetails.baggage
      .checkedBaggageAllowed
    baggageObj.hasNoCheckedBaggageOnly =
      !tripData.flightDetails.baggage.checkedBaggageAllowed &&
      !tripData.flightDetails.baggage.complimentaryBaggage
    baggageObj.baggageDataList = tripData.flightDetails.baggage.complimentaryBaggage
      .filter(bag => !!bag.type && (!!bag.count || !!bag.weight))
      .map(bagg => ({
        iconName: getBaggageIcon(bagg.type),
        mainDisplayName: getBaggageDisplayName(bagg.type, translation?.listing),
        mainDisplayNameQty: getBaggageMainDisplayNameQty(bagg),
        value: getBaggageValue(bagg, translation)
      }))
  }
  return baggageObj
}

export const checkAirlineProfile = (airlineProfile = "") => {
  return airlineProfile?.toLowerCase() === "dotrez"
}

export const checkSegmentIfHasAA = (segments, isULEFlagEnabled, infant) => {
  return (
    isULEFlagEnabled &&
    infant > 0 &&
    !!segments.filter(seg => seg.airline === "AK").length
  )
}

export const checkIfHasAARoute = (
  aggSearchResults,
  queryParams,
  selectedDepartFlight,
  isFromFilter = false
) => {
  let hasAARoute = false
  if (
    aggSearchResults &&
    aggSearchResults.searchResults &&
    aggSearchResults.searchResults.trips
  ) {
    if (
      queryParams.type === TYPE.PAIRED &&
      (aggSearchResults.searchResults?.trips[0]?.flightsList ||
        aggSearchResults.searchResults?.trips[1]?.flightsList)
    ) {
      const flightList = selectedDepartFlight
        ? aggSearchResults.searchResults?.trips[1]?.flightsList
        : aggSearchResults.searchResults?.trips[0]?.flightsList

      if (flightList) {
        flightList.forEach(trip => {
          if (!hasAARoute) {
            if (isFromFilter)
              hasAARoute = checkAirlineProfile(trip.airlineProfile)
            else
              hasAARoute =
                queryParams.infant > 0 &&
                checkAirlineProfile(trip.airlineProfile)
          }
        })
      }

      if (
        !hasAARoute &&
        aggSearchResults.searchResults?.recommendedFlights &&
        (aggSearchResults.searchResults?.recommendedFlights[0]?.flightsList ||
          aggSearchResults.searchResults?.recommendedFlights[1]?.flightsList)
      ) {
        const recommendedFlightList = selectedDepartFlight
          ? aggSearchResults.searchResults?.recommendedFlights[1]?.flightsList
          : aggSearchResults.searchResults?.recommendedFlights[0]?.flightsList
        if (recommendedFlightList) {
          recommendedFlightList.forEach(trip => {
            if (isFromFilter)
              hasAARoute = checkAirlineProfile(trip.airlineProfile)
            else
              hasAARoute =
                queryParams.infant > 0 &&
                checkAirlineProfile(trip.airlineProfile)
          })
        }
      }
    }
  }
  return hasAARoute
}
